import {
  SMALL_FILE_SIZE,
  MEDIUM_FILE_SIZE,
  LARGE_FILE_SIZE,
} from '../constants';

export const calculateChunkSize = (fileSize: number) => {
  if (fileSize < SMALL_FILE_SIZE) {
    return SMALL_FILE_SIZE / 2;
  } else if (fileSize <= MEDIUM_FILE_SIZE) {
    return MEDIUM_FILE_SIZE / 10;
  } else {
    return LARGE_FILE_SIZE / 20;
  }
};
